import React from "react";

const KTWindowSizeContext = React.createContext();

export default KTWindowSizeContext;
